import React from "react";
import * as Styles from "../../../../common-deprecated/styles/v2/toyota/components/Form";
import Icon, { IconExclamation } from "../../../../common-deprecated/styles/v2/toyota/globals/Icon";
import { IconWrapper } from "../../../../common-deprecated/styles/v2/toyota/globals/IconWrapper";
import type { TradeInAemResolveItemConfig } from "../../../utils/types";
import { useTradeInAemLabel } from "../../../utils/labels";

type Props = {
    dropdownConfig: TradeInAemResolveItemConfig;
    onOptionSelect: (key: string, id: string) => void;
    disabled: boolean;
};

const FindVehicleDropdown = (props: Props): JSX.Element | null => {
    const { dropdownConfig, onOptionSelect, disabled } = props;
    const { required, options, labelKey, vehicleProperty, selectedOptionId } = dropdownConfig;
    const [selectLabel, titleLabel] = useTradeInAemLabel(["tradeInAemResolveSelect", labelKey]);

    const error = false;

    return (
        <>
            <Styles.InputField hasError={error} mt={2}>
                <Styles.InputLabel htmlFor={vehicleProperty}>{titleLabel}</Styles.InputLabel>
                <Styles.Select>
                    <select
                        disabled={disabled}
                        id={vehicleProperty}
                        required={required}
                        onChange={(event) => onOptionSelect(vehicleProperty, event.target.value)}
                        value={selectedOptionId || ""}
                    >
                        {/* If the input is required, prevent the placeholder from being selectable */}
                        <option value="" disabled={required}>
                            {selectLabel}
                        </option>
                        {options.map((option) => (
                            <option key={option.id} value={option.id}>
                                {option.label}
                            </option>
                        ))}
                    </select>
                </Styles.Select>
                <Styles.Icon>
                    <Icon variant="chevronDown" />
                </Styles.Icon>
            </Styles.InputField>
            {error && (
                <Styles.ErrorField>
                    <span>This is an test error text.</span>
                    <IconWrapper iconColor="primaryRed">
                        <IconExclamation />
                    </IconWrapper>
                </Styles.ErrorField>
            )}
        </>
    );
};

export default FindVehicleDropdown;
